var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "card float-left ml-3 card-chat-booking" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c("div", { staticClass: "flex-fill" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.service_item.select")))
                ])
              ]),
              _vm._v(" "),
              _vm.serviceItems && !_vm.isConfirmed
                ? _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "text-info",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.clearSelectedServiceItems()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.service_item.clear")) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card pointer-item mb-1 border-divider",
              on: {
                click: function($event) {
                  return _vm.openServiceItemModal()
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                !_vm.serviceItems
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-start align-items-center"
                      },
                      [
                        _vm.parentService
                          ? _c("div", [
                              _c("img", {
                                attrs: {
                                  src: _vm.parentService.icon_url,
                                  width: "24"
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex-fill px-3" }, [
                          _vm._v(_vm._s(_vm.$t("message.service_item.select")))
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-start align-items-top"
                      },
                      [
                        _vm.parentService
                          ? _c("div", [
                              _c("img", {
                                staticClass: "active-svg-icon",
                                attrs: {
                                  src: _vm.parentService.icon_url,
                                  width: "32"
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-fill px-3" },
                          [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.service_item.selected_list")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.serviceItems, function(serviceItem) {
                              return _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("multiLangName")(serviceItem)
                                    ) +
                                    ": " +
                                    _vm._s(serviceItem.count) +
                                    " " +
                                    _vm._s(
                                      _vm._f("multiLangName")(
                                        serviceItem.item_unit
                                      )
                                    ) +
                                    "\n              "
                                )
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-info text-small mt-2" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("message.service_item.remark"))
                                )
                              ]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        !_vm.isConfirmed
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-info rounded-pill"
                                },
                                [_vm._v(_vm._s(_vm.$t("message.button.edit")))]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.serviceItems
            ? _c("section", { staticClass: "pt-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center"
                  },
                  [
                    _c("div", { staticClass: "flex-fill" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("message.booking.new_booking.subtotal")
                          ) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-info" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("currency")(_vm.subtotal)) +
                          "\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mt-2" }, [
                  !_vm.isConfirmed
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-block",
                          on: { click: _vm.confirmServiceItems }
                        },
                        [_vm._v(_vm._s(_vm.$t("message.button.submit")))]
                      )
                    : _c("div", { staticClass: "text-center mt-3" }, [
                        _c("i", {
                          staticClass: "fal fa-check-circle text-success"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("message.service_item.confirmed")) +
                            "\n          "
                        )
                      ])
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.parentService && _vm.parentService.has_service_items
        ? _c("service-item-modal", {
            ref: "serviceItemModal",
            attrs: { parentService: _vm.parentService },
            on: { selectServiceItems: _vm.setServiceItems }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-plus-circle text-info fa-lg" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a7086aa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7086aa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/ServiceItemMessage.vue
// module id = 2237
// module chunks = 0